var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useClassNames } from '../../hooks/use-class-names';
import { Span } from '../typography/typography';
import styles from './links.module.scss';
var defaultHintId = 'cancelHint';
export var Link = React.forwardRef(function (_a, ref) {
    var _b;
    var globalStyles = _a.cfg, _c = _a.underline, underline = _c === void 0 ? false : _c, className = _a.className, testId = _a.testId, _d = _a.taskList, taskList = _d === void 0 ? false : _d, hint = _a.hint, hintCfg = _a.hintCfg, _e = _a.hintId, hintId = _e === void 0 ? defaultHintId : _e, children = _a.children, props = __rest(_a, ["cfg", "underline", "className", "testId", "taskList", "hint", "hintCfg", "hintId", "children"]);
    var classNames = useClassNames(globalStyles, [
        styles.link,
        (_b = {}, _b[styles['link-underline']] = underline, _b),
        className,
    ]);
    var anchorProps = __assign({ 'data-testid': testId, className: classNames, href: props.href ? props.href : '#', onClick: null, 'aria-describedby': hint ? hintId : null }, props);
    if (props.onClick && (!props.href || taskList)) {
        anchorProps.onClick = function (e) {
            e.preventDefault();
            props.onClick();
        };
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("a", __assign({ ref: ref }, anchorProps), children),
        hint && (React.createElement(Span, { className: styles.hint, id: hintId, cfg: __assign({}, hintCfg) }, hint))));
});
//# sourceMappingURL=links.js.map